module.exports = __webpack_public_path__ + "img/hlj.393a5b5d.png";